// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCategoryInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31">
            <path
                fill="currentColor"
                d="M9.5625,0.375 L3.1875,0.375 C1.42707068,0.375 0,1.80206966 0,3.5625 L0,9.9375 C0,11.6972656 1.42707068,13.125 3.1875,13.125 L9.5625,13.125 C11.3222656,13.125 12.75,11.6972656 12.75,9.9375 L12.75,3.5625 C12.75,1.80206966 11.3222656,0.375 9.5625,0.375 Z M26.5625,17.375 L20.1875,17.375 C18.4277344,17.375 17,18.8027344 17,20.5625 L17,26.9375 C17,28.6979303 18.4270697,30.125 20.1875,30.125 L26.5625,30.125 C28.3229303,30.125 29.75,28.6979303 29.75,26.9375 L29.75,20.5625 C29.75,18.8027344 28.3222656,17.375 26.5625,17.375 Z M26.5625,0.375 L20.1875,0.375 C18.4277344,0.375 17,1.80206966 17,3.5625 L17,9.9375 C17,11.6972656 18.4277344,13.125 20.1875,13.125 L26.5625,13.125 C28.3222656,13.125 29.75,11.6972656 29.75,9.9375 L29.75,3.5625 C29.75,1.80206966 28.3222656,0.375 26.5625,0.375 Z M9.5625,17.375 L3.1875,17.375 C1.42707068,17.375 0,18.8027344 0,20.5625 L0,26.9375 C0,28.6972656 1.42707068,30.125 3.1875,30.125 L9.5625,30.125 C11.3222656,30.125 12.75,28.6972656 12.75,26.9375 L12.75,20.5625 C12.75,18.8027344 11.3222656,17.375 9.5625,17.375 Z"
            />
        </svg>
    );
};

export default React.memo(IconCategoryInactive);
